module.exports = __webpack_public_path__ + "img/symbol_6.793524a7.png";